
export default function ParkingAccessibility() {
  const parkingFeatures = [
    {
      icon: 'ri-parking-box-line',
      title: '대규모 주차 공간',
      description: '5-7층 3개 층에 걸친 500대 이상 수용 가능한 주차시설'
    },
    {
      icon: 'ri-cpu-line',
      title: '스마트 주차 시스템',
      description: 'AI 기반 자동 주차 안내 및 빈자리 실시간 확인'
    },
    {
      icon: 'ri-charging-pile-2-line',
      title: '전기차 충전소',
      description: '50개 이상의 전기차 급속 충전 시설 완비'
    },
    {
      icon: 'ri-shield-check-line',
      title: '안전 시스템',
      description: 'CCTV 및 24시간 보안 관제로 안전한 주차 환경'
    }
  ];

  const accessibilityFeatures = [
    {
      icon: 'ri-subway-line',
      title: '지하철 접근성',
      description: '2호선 서초역 도보 5분, 3호선 교대역 도보 8분 거리'
    },
    {
      icon: 'ri-bus-line',
      title: '버스 노선',
      description: '주요 간선버스 및 지선버스 20개 이상 노선 이용 가능'
    },
    {
      icon: 'ri-road-map-line',
      title: '도로 접근성',
      description: '강남대로, 서초대로 인접으로 서울 전역 빠른 이동'
    },
    {
      icon: 'ri-building-line',
      title: '주변 인프라',
      description: '법원, 검찰청, 대형 병원, 백화점 등 주요 시설 인접'
    }
  ];

  return (
    <section id="parking" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">주차 & 접근성</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            강남3구 주차난 해소에 기여하는 대규모 주차시설과<br />
            서울 어디든 빠르게 이동 가능한 최고의 입지를 자랑합니다.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-8">방문객 전용 주차장</h3>
            <div className="space-y-6">
              {parkingFeatures.map((feature, index) => (
                <div key={index} className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all cursor-pointer">
                  <div className="flex items-start">
                    <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mr-5 flex-shrink-0">
                      <i className={`${feature.icon} text-2xl text-teal-600`}></i>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h4>
                      <p className="text-gray-600">{feature.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-8 bg-teal-600 rounded-xl p-8 text-white">
              <div className="flex items-center mb-4">
                <i className="ri-car-line text-4xl mr-4"></i>
                <div>
                  <div className="text-4xl font-bold">500+</div>
                  <div className="text-teal-100">주차 가능 대수</div>
                </div>
              </div>
              <p className="text-teal-50">
                강남3구 최대 규모의 방문객 전용 주차시설로 지역 주차난 해소에 크게 기여합니다.
              </p>
            </div>
          </div>
          <div className="relative h-[600px] rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://public.readdy.ai/ai/img_res/7b3d925d10d9475cbe7d95c278f3ae85.jpg" 
              alt="주차 시설" 
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div>
          <h3 className="text-3xl font-bold text-gray-900 mb-10 text-center">탁월한 접근성</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {accessibilityFeatures.map((feature, index) => (
              <div key={index} className="bg-white rounded-xl p-8 text-center hover:shadow-lg transition-all cursor-pointer group">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-teal-600 transition-colors">
                  <i className={`${feature.icon} text-3xl text-teal-600 group-hover:text-white transition-colors`}></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h4>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
          <div className="relative h-96 rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://readdy.ai/api/search-image?query=Seoul%20Gangnam%20district%20urban%20map%20showing%20transportation%20network%20with%20subway%20lines%20and%20major%20roads%2C%20professional%20city%20planning%20visualization%20with%20clean%20design%20showing%20accessibility%20and%20infrastructure%2C%20modern%20urban%20development%20location%20map&width=1400&height=600&seq=accessibility-map&orientation=landscape" 
              alt="교통 접근성" 
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
